import TransactionCollection from "utilities/transactionFinder/TransactionCollection";

export default class PlaidTransactionCollection extends TransactionCollection {
	constructor() {
		super();
		this.transactionsThatHavePendingParent = {};
		this.transactionsThatArePending = {};
	}

	_getTransactionListKeyFromTransaction(transaction) {
		if(transaction.plaid_transaction_id) {
			return transaction.plaid_transaction_id;
		}
		console.log('attempted to add', transaction);
		throw new Error('transaction has no plaid_transaction_id');
	}

	getPlaidTransactionById(id) {
		return this.transactions.has(id);
	}

	addTransaction(transaction) {
		super.addTransaction(transaction);
		if(transaction.pending) {
			this.transactionsThatArePending[transaction.plaid_transaction_id] = transaction;
		}
		if(transaction.plaid_pending_transaction_id) {
			this.transactionsThatHavePendingParent[transaction.plaid_pending_transaction_id] = transaction;
		}
	}

	removeTransaction(transaction) {
		super.removeTransaction(transaction);
	}

	hasMonthBeenRetrieved(year, month) {
		const result = this.monthsThatHaveBeenRetrieved?.[year]?.[month];
		return result;
	}

	markMonthAsRetrieved(year, month) {
		if(!this.monthsThatHaveBeenRetrieved[year]) {
			this.monthsThatHaveBeenRetrieved[year] = {};
		}
		if(!this.monthsThatHaveBeenRetrieved[year][month]) {
			this.monthsThatHaveBeenRetrieved[year][month] = true;
		}
	}
}